import React, { FC } from 'react';

import TimelineTools from './TimelineTools';
import {
  EventInfoCard,
  EventImage,
  GeneralInfo,
  TimeInfo,
  Location,
  TypeInfo,
  SongsInfo,
  QuestionsInfo,
  Labels,
} from 'components/timeline/TimelineInfo';

const TimelineTemplateInfo: FC = () => (
  <EventInfoCard>
    <EventImage placeholder="Add template photo" />
    <GeneralInfo>
      <TypeInfo />
      <SongsInfo />
      <QuestionsInfo />
      <Location />
      <TimeInfo />
      <Labels />
    </GeneralInfo>
    <TimelineTools />
  </EventInfoCard>
);

export default TimelineTemplateInfo;
